import { ApplicationConfig, provideZoneChangeDetection } from '@angular/core';
import { provideRouter } from '@angular/router';

import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { routes } from './app.routes';
import { authInterceptor } from './core/interceptors/auth/auth.interceptor';
import { errorInterceptor } from './core/interceptors/error/error.interceptor';

import { APP_INITIALIZER } from '@angular/core';
import { firstValueFrom } from 'rxjs';
import { AuthDataService } from './core/data-access/data/auth-data.service';
import { payloadEncryptionInterceptor } from './core/interceptors/payload-encryption/payload-encryption.interceptor';

export function authInitializer(auth: AuthDataService) {
  return () => firstValueFrom(auth.initSession());
}

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes),
    provideHttpClient(
      withInterceptors([errorInterceptor, authInterceptor, payloadEncryptionInterceptor])
    ),
    {
      provide: APP_INITIALIZER,
      useFactory: authInitializer,
      deps: [AuthDataService],
      multi: true
    }
  ]
};
